/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 06.07.2016
 *
 */
'use strict';
import L from 'external/leaflet';
import DrawerGeoJsonLayer from '../layer/DrawerGeoJsonLayer';

export default class ExportToImagePlugin {
    constructor(props, config){
        this.exportToImage = this.exportToImage.bind(this);
    }

    init(map, o){
        this.map = map;
        map.options.preferCanvas = true;

        const exportControl = L.Control.extend({
            options: {
                position: 'topleft'
            },
            onAdd: (map) => {
                this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                this.icon = L.DomUtil.create('span', 'icon icon-map-download', this.container);
                this.container.setAttribute('title', 'Karte als Bild exportieren');
                this.container.setAttribute('role', 'button');

                L.DomEvent.on(this.container, 'click', this.exportToImage, this);
                return this.container;
            }
        });

        map.addControl(new exportControl());
    }

    update(map, o){
        if (o.drawerGeoJSON) {
            this.lastDrawerGeoJSON = o.drawerGeoJSON;
            if (!this.drawerGeoJsonLayer) {
                this.drawerGeoJsonLayer = new DrawerGeoJsonLayer(o.drawerGeoJSON, {
                    ...o,
                    renderer: L.canvas()
                }).addTo(map);
                this.focus();
            } else {
                if (o.drawerGeoJSON !== this.lastDrawerGeoJSON) {
                    this.drawerGeoJsonLayer.clearLayers();
                    this.drawerGeoJsonLayer.addData(o.drawerGeoJSON);
                    this.focus();
                } else if (this.drawerGeoJsonLayer.getLayers().length === 0 && o.drawerGeoJSON && o.drawerGeoJSON.features && o.drawerGeoJSON.features.length > 0) {
                    this.drawerGeoJsonLayer.addData(o.drawerGeoJSON);
                    this.focus();
                }
            }
        } else if (this.drawerGeoJsonLayer) {
            this.drawerGeoJsonLayer.clearLayers();
        }

    }

    focus(){
        const bounds = this.drawerGeoJsonLayer && this.drawerGeoJsonLayer.getBounds();
        if (bounds && bounds.isValid()) {
            this.map.fitBounds(bounds);
        }
    }

    exportToImage(){
        fetch('/o/data-preview/SituationMapData', {
            method: 'POST',
            body: JSON.stringify(this.lastDrawerGeoJSON)
        })
            .then(res => {
                if (!res.ok) {
                    console.error('Download fehlgeschlagen! Status: ', res);
                    window.alert('Download fehlgeschlagen! Status: ' + res.status);
                }
                return res.blob();
            })
            .then(blob => {
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, 'Lagekarte.jpg');
                } else {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'Lagekarte';
                    link.click();
                }
            })
            .catch(err => {
                window.alert(err);
            });
    }
}



// WEBPACK FOOTER //
// ./js/plugins/ExportToImagePlugin.js